// src/components/FAQs.js
import React from 'react';
import {
  Box,
  Heading,
  Text,
  VStack,
  HStack,
  Icon,
  Button,
  useColorModeValue,
  Flex,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from '@chakra-ui/react';
import { FiPhoneCall } from 'react-icons/fi';
import { BsChatQuote } from 'react-icons/bs';

export default function FAQs() {
  const bgColor = useColorModeValue('gray.50', 'gray.900');

  const faqData = [
    {
      question: 'What services does your company provide?',
      answer: 'We offer a comprehensive suite of construction services, including commercial, industrial, and residential construction, as well as large-scale renovations, remodeling, and pre-construction planning.',
    },
    {
      question: 'Are there any hidden costs?',
      answer: 'Transparency is a core value for us. All potential costs are outlined in our detailed project proposal. Any changes to the scope of work that may affect the budget are always discussed and approved by you in advance.',
    },
    {
      question: 'How is the project cost determined?',
      answer: 'The project cost is determined by a number of factors including the scope of work, materials used, labor, and any special requirements. We provide a detailed quote after the initial consultation.',
    },
    {
      question: 'How can I track the progress of my project?',
      answer: 'We provide regular updates and have a client portal where you can track the progress of your project in real-time.',
    },
    {
      question: 'Do you provide free consultations or quotes?',
      answer: 'Yes, we offer a free, no-obligation consultation and quote for all potential projects. Contact us to schedule yours today.',
    },
    {
      question: 'What types of projects do you specialize in?',
      answer: 'We specialize in a wide range of projects including residential, commercial, and industrial construction, as well as renovations and remodeling.',
    },
  ];

  return (
    <Box as="section" bg={bgColor} py={{ base: 16, md: 24 }}>
      <Box maxW="7xl" mx="auto" px={8}>
        {/* Section Header */}
        <VStack spacing={4} textAlign="center" mb={12}>
          <Text color="orange.500" fontWeight="bold">FAQS</Text>
          <Heading as="h2" size="2xl" fontWeight="bold">
            Question? <Text as="span" color="orange.500">Look here.</Text>
          </Heading>
        </VStack>

        <Flex direction={{ base: 'column', lg: 'row' }} gap={10}>
          {/* Left Side: Accordion */}
          <VStack flex="2" w="full" spacing={4}>
            <Accordion allowMultiple w="full">
              {faqData.map((faq, index) => (
                <AccordionItem key={index} bg="white" borderRadius="md" mb={4} border="none">
                  <h2>
                    <AccordionButton _expanded={{ bg: 'blue.800', color: 'white' }} py={4} borderRadius="md">
                      <Box flex="1" textAlign="left" fontWeight="bold">
                        {faq.question}
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4} bg="white" borderBottomRadius="md">
                    {faq.answer}
                  </AccordionPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </VStack>

          {/* Right Side: Contact Cards */}
          <VStack flex="1" w="full" spacing={6}>
            <VStack
              bg="blue.800"
              color="white"
              p={8}
              borderRadius="lg"
              spacing={6}
              align="center"
              textAlign="center"
              w="full"
            >
              <Icon as={BsChatQuote} boxSize={10} color="orange.400" />
              <Heading as="h3" size="md">You have different questions?</Heading>
              <Text>Our team will answer all your questions. We ensure a quick response.</Text>
              <Button colorScheme="orange">Contact Us</Button>
            </VStack>
            <VStack
              bg="white"
              p={8}
              borderRadius="lg"
              boxShadow="md"
              spacing={4}
              align="center"
              textAlign="center"
              w="full"
            >
              <Icon as={FiPhoneCall} boxSize={8} color="orange.500" />
              <Text fontWeight="bold">Your Comfort, Our Priority</Text>
              <Heading as="h4" size="lg" color="blue.800">24/7 Service</Heading>
              <Text fontSize="xl" fontWeight="bold">+251911499494</Text>
            </VStack>
          </VStack>
        </Flex>
      </Box>
    </Box>
  );
}